import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { ProjectPublicResponse } from '@app/models/project.models';
import { CurrencyFormatPipe } from '@app/pipes/currency-format.pipe';
import { CardComponent } from '@app/ui-components/card/card.component';
import { InfoLabelComponent } from '@app/ui-components/info-label/info-label.component';
import { LabeledContentComponent } from '@app/ui-components/labeled-content/labeled-content.component';

@Component({
  selector: 'app-project-details-section-b',
  imports: [
    DatePipe,
    CurrencyFormatPipe,
    CardComponent,
    LabeledContentComponent,
    InfoLabelComponent,
  ],
  templateUrl: './project-details-section-b.component.html',
  styleUrl: './project-details-section-b.component.scss',
})
export class ProjectDetailsSectionBComponent {
  projectDetails = input.required<ProjectPublicResponse>();
  protected translationKey = 'projectDetails.sectionB.';
}
